import { app } from '../../../../app';
import { Controller } from './phone-number-list.controller';

app.component('userPhoneNumberList', {
    bindings: {
        account: '<',
        phoneNumbers: '<',
    },
    controller: Controller,
    templateUrl: require('./phone-number-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/list/phone-number-list.component.js